import "./style.less";

export default function UserBookings() {
    return {
        restrict: "E",
        scope: {
            bookings: "<",
            bookingResources: "<",
        },

        template: require("./template.html"),
        controller: function ($scope) {
            $scope.oneAtATime = true;

            // TO DO ::: LOW ::: accordian is-disabled click issue

            $scope.preventPropagation = ($event) => {
                $event.stopPropagation();
            };

            $scope.toggleObj = function ($event, obj) {
                obj._isOpen = !obj._isOpen;

                $event.stopPropagation();
            };
        },
    };
}
